<template>
  <div>
    <v-card class="mt-4 pt-2 pb-2" flat>
      <v-card-actions>
        <v-select
          outlined
          v-model="SelStatus"
          :items="StatusName"
          item-text="event_name"
          item-value="event_id"
          label="Select Event"
          dense
          :rules="[(v) => !!v || 'Event is required']"
          required
          return-object
          hide-details
          full-width
        ></v-select>
        <v-btn color="primary" class="ml-3" raised dark large @click="load">
          RELOAD
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-row>
      <v-col cols="12" md="12">
        <v-card flat>
          <v-card-text>Event Preference</v-card-text>
          <v-list>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>JOB TYPE ADDINS</v-list-item-title>
                <v-list-item-subtitle></v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-switch
                  v-model="jobtypeswitch1"
                  inset
                  :label="`${jobtypeswitch1.toString()}`"
                ></v-switch>
              </v-list-item-action>
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>PHOTO SIZE</v-list-item-title>
                <v-list-item-subtitle></v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-text-field
                  label="Size"
                  v-model="inputclass.photo_size"
                  outlined
                  dense
                  hide-details
                ></v-text-field>
              </v-list-item-action>
            </v-list-item>

            <v-divider></v-divider>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>NAME</v-list-item-title>
                <v-list-item-subtitle>SET NO OF CHAR</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-text-field
                  label="Size"
                  v-model="inputclass.applicant_name_size"
                  outlined
                  dense
                  hide-details
                ></v-text-field>
              </v-list-item-action>
            </v-list-item>

            <v-divider></v-divider>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>COMPANY</v-list-item-title>
                <v-list-item-subtitle>SET NO OF CHAR</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-text-field
                  label="Size"
                  v-model="inputclass.company_name_size"
                  outlined
                  dense
                  hide-details
                ></v-text-field>
              </v-list-item-action>
            </v-list-item>

            <v-divider></v-divider>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>DESIGNATION</v-list-item-title>
                <v-list-item-subtitle>SET NO OF CHAR</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-text-field
                  label="Size"
                  v-model="inputclass.designations"
                  outlined
                  dense
                  hide-details
                ></v-text-field>
              </v-list-item-action>
            </v-list-item>

            <v-divider></v-divider>
            <v-spacer></v-spacer>
            <v-list-item-action>
              <v-btn
                color="success "
                class="ml-3"
                raised
                dark
                large
                @click="savechanges"
              >
                SAVE CHANGES
              </v-btn>
            </v-list-item-action>
          </v-list>
        </v-card>
      </v-col>

      <v-col cols="12" md="12">
        <v-card flat>
          <v-card-text>File Upload</v-card-text>
          <v-list>
            <v-file-input
              v-model="selectedFile"
              label="Choose a file"
              outlined
              show-size
              prepend-icon="mdi-upload"
              @change="onFileSelected"
            ></v-file-input>

            <!-- Upload Button -->
            <v-btn
              color="primary"
              class="mt-3"
              :disabled="!selectedFile"
              @click="uploadFile"
            >
              Upload
            </v-btn>

            <v-alert
              v-if="uploadStatus"
              type="success"
              class="mt-3"
              border="left"
              elevation="2"
            >
              {{ uploadStatus }}
            </v-alert>
          </v-list>
        </v-card>
      </v-col>
    </v-row>

    <v-snackbar v-model="snackbar" shaped top :color="snackbarcolor">
      {{ snackbartext }}
      <v-btn color="indigo" text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data: () => ({
    selectedFile: null,
    uploadStatus: "",
    Mode: "New",
    jobtypeswitch1: false,
    snackbar: false,
    snackbartext: "",
    snackbarcolor: "primary",
    loading: false,
    checkbox: "",
    chkselected: "",
    selected: [],
    StatusName: [],
    SelStatus: "",
    search: "",
    search1: "",
    btrue: true,
    inputclass: {
      other_jobtype: "",
      company_name_size: "",
      applicant_name_size: "",
      designations: "",
      photo_size: "",
      event_id: "",
    },
  }),
  mounted() {
    this.bindcompanytype();
    // this.Gridbindjobtype();
    // this.Gridbindjobtype(4);
  },
  watch: {
    selected: function () {},
    bindcompanytype: function () {},
  },
  methods: {
    showSnackbar: function (scolor, stext) {
      this.snackbar = true;
      this.snackbartext = stext;
      this.snackbarcolor = scolor;
    },

    async uploadFile() {
      if (!this.selectedFile) return;

      try {
        const formData = new FormData();
        formData.append("file", this.selectedFile);

        // Example: using fetch (replace URL with your backend endpoint)
        const response = await fetch(
          "https://accred.api.dnanetworks.in/Event/UploadEmailTemplate/" + "act-ranchi" + "/" + "otp",
          {
            method: "POST",
            headers: {
              "appkey": "ticketgenieapikey", // 👈 custom header
            },
            body: formData,
          }
        );

        if (response.ok) {
          this.uploadStatus = "✅ File uploaded successfully!";
        } else {
          this.uploadStatus = "❌ File upload failed!";
        }
      } catch (error) {
        console.error(error);
        this.uploadStatus = "⚠️ Error uploading file!";
      }
    },

    onFileSelected(file) {
      this.uploadStatus = "Y";
      console.log("Selected file:", file);
    },

    load: function () {
      //alert(this.SelCompany.companytype_id)
      this.Gridbindjobtype(this.SelStatus.event_id);
    },
    savechanges: function () {
      // this.inputclass.cid = [];
      if (this.jobtypeswitch1 == true) {
        this.inputclass.other_jobtype = "1";
      }
      if (this.jobtypeswitch1 == false) {
        this.inputclass.other_jobtype = "0";
      }
      // this.inputclass.other_jobtype=this.jobtypeswitch1
      this.inputclass.event_id = this.SelStatus.event_id;
      console.log(this.inputclass);
      if (this.Mode == "New") {
        axios
          .post(this.$apiPath + "Event_Preferences", this.inputclass, {
            headers: { Appkey: this.$aKey },
          })
          .then((res) => {
            if (res.data.status == "Success") {
              this.showSnackbar("Success", "Prefrence has been set !");
            }
          })
          .catch()
          .finally();
      }

      if (this.Mode == "Edit") {
        axios
          .put(
            this.$apiPath + "Event_Preferences/" + this.SelStatus.event_id,
            this.inputclass,
            {
              headers: { Appkey: this.$aKey },
            }
          )
          .then((res) => {
            if (res.data.status == "Success") {
              this.showSnackbar("Success", "Prefrence has been Edited !");
            }
          })
          .catch()
          .finally();
      }
    },

    handleClick(value) {
      alert(value);
    },
    bindcompanytype: async function () {
      await axios
        .get(this.$apiPath + "Event", {
          headers: { Appkey: this.$aKey },
        })
        .then((res) => {
          this.StatusName = res.data.result;
        })
        .catch()
        .finally();
    },

    Gridbindjobtype: async function (comid) {
      this.inputclass.applicant_name_size = "";
      this.inputclass.company_name_size = "";
      this.inputclass.designations = "";
      this.inputclass.photo_size = "";
      this.jobtypeswitch1 = false;
      this.Mode = "New";
      await axios
        .get(this.$apiPath + "Event_Preferences/GetByEventId/" + comid, {
          headers: { Appkey: this.$aKey },
        })
        .then((res) => {
          console.log(res.data.result);
          //this.arrreason = res.data.result;
          if (res.data.result.length > 0) {
            this.inputclass.applicant_name_size =
              res.data.result[0].applicant_name_size;
            this.inputclass.company_name_size =
              res.data.result[0].company_name_size;
            this.inputclass.designations = res.data.result[0].designations;
            this.inputclass.photo_size = res.data.result[0].photo_size;
            this.Mode = "Edit";
            if (res.data.result[0].other_jobtype == "1") {
              this.jobtypeswitch1 = true;
            } else {
              this.jobtypeswitch1 = false;
            }
            //   this.selected = this.arrreason.filter(
            //     (task) => task.event_id == this.SelStatus.event_id
            //   );
          }
        })
        .catch()
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>